<template>
  <div
    class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3"
  >
    <h4 class="mb-0">{{ $t("company_orders.title") }}</h4>
    <div class="d-flex flex-wrap align-items-center gap-2">
      <!-- A counter stays while its filter is on, as its count can reach 0 under it. -->
      <template v-for="counter in counters" :key="counter.key">
        <button
          v-if="counter.count > 0 || counter.active"
          type="button"
          :class="
            counter.attention
              ? 'badge pill-attention'
              : 'btn btn-link btn-sm text-body-secondary p-0 me-2'
          "
          :aria-pressed="counter.active"
          @click="$emit('toggle:counter', counter)"
        >
          {{ $t(counter.label, { count: counter.count }, counter.count) }}
          <FontAwesomeIcon
            v-if="counter.active"
            :icon="['far', 'xmark']"
            class="ms-1"
          />
        </button>
      </template>
      <template v-if="showBatchActions">
        <button
          v-if="isAdmin"
          type="button"
          class="btn btn-sm btn-success"
          :disabled="isBatchProcessing"
          @click="$emit('confirm:all')"
        >
          <FontAwesomeIcon
            :icon="isBatchProcessing ? 'spinner' : ['far', 'check-double']"
            :class="{ 'fa-spin': isBatchProcessing }"
            class="me-1"
          />
          {{ $t("company_orders.confirm_all") }}
        </button>
        <button
          type="button"
          class="btn btn-sm btn-danger"
          :disabled="isBatchProcessing"
          @click="$emit('reject:all')"
        >
          <FontAwesomeIcon
            :icon="isBatchProcessing ? 'spinner' : ['far', 'circle-xmark']"
            :class="{ 'fa-spin': isBatchProcessing }"
            class="me-1"
          />
          {{ $t("company_orders.reject_all") }}
        </button>
      </template>
      <button
        type="button"
        class="btn btn-sm btn-outline-secondary"
        :disabled="exportDisabled"
        @click="$emit('export')"
      >
        <FontAwesomeIcon :icon="['far', 'download']" class="me-1" />
        {{ $t("company_orders.export_csv") }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { StatusCounterSpec } from "./transactionFilters";

/** A title-row counter with its count over the loaded orders and whether its filter is on. */
type StatusCounter = StatusCounterSpec & { count: number; active: boolean };

defineProps<{
  counters: StatusCounter[];
  showBatchActions: boolean;
  isAdmin: boolean;
  isBatchProcessing: boolean;
  exportDisabled: boolean;
}>();

defineEmits<{
  "toggle:counter": [counter: StatusCounterSpec];
  "confirm:all": [];
  "reject:all": [];
  export: [];
}>();
</script>
